import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import cartReducer from './cartSlice';
import configReducer from './configSlice';
import formalityRequestReducer from './formalityRequestSlice';
const store = configureStore({
  reducer: {
    user: userReducer,
    cart: cartReducer,
    config: configReducer,
    formalityRequest: formalityRequestReducer,
  },
});
export default store;
